import { render, staticRenderFns } from "./provideOrganizationDialog.vue?vue&type=template&id=a19d4c28&scoped=true&"
import script from "./provideOrganizationDialog.vue?vue&type=script&lang=js&"
export * from "./provideOrganizationDialog.vue?vue&type=script&lang=js&"
import style0 from "./provideOrganizationDialog.vue?vue&type=style&index=0&id=a19d4c28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19d4c28",
  null
  
)

export default component.exports